import {RESPONSE_STATUS_SET, RESPONSE_STATUS_INIT} from './actions.responseStatus.types'

export function setResponseStatus(status) {
  return {type: RESPONSE_STATUS_SET, status}
}

export function initResponseStatus() {
  return {type: RESPONSE_STATUS_INIT}
}
